// 登录页主题配置 —— 颜色全部取自 Figma 设计稿（4 套配色：橙/绿/蓝/粉）
// 设计稿画布固定 1920×1080，下方坐标均为设计稿像素值。

export type Theme = 'orange' | 'green' | 'blue' | 'pink';

export interface ThemeColors {
  /** 页面整体背景（外层视口底色，对应主题的极浅调） */
  pageBg: string;
  /** 左侧大卡片背景 */
  cardBg: string;
  /** 输入框背景 */
  inputBg: string;
  /** 登录按钮背景 */
  buttonBg: string;
  /** 登录按钮文字/图标颜色 */
  buttonText: string;
  /** 顶部「關於我們」胶囊背景 */
  pillAbout: string;
  /** 顶部「活動介紹」胶囊背景 */
  pillActivity: string;
  /** 链接 / 强调色（忘記密碼、注冊） */
  link: string;
  /** 语言切换轨道底色（即该配色的控件强调色） */
  chip: string;
  /** 主题切换器中该配色对应的圆点颜色 */
  dot: string;
}

export const THEME: Record<Theme, ThemeColors> = {
  orange: { pageBg: '#FEFCF9', cardBg: '#FFE7D0', inputBg: '#F3F3F4', buttonBg: '#5BC9E8', buttonText: '#FFFFFF', pillAbout: '#FF7F7B', pillActivity: '#FFD57B', link: '#5BC9E8', chip: '#5BC9E8', dot: '#FFE7D0' },
  green:  { pageBg: '#F5F7E2', cardBg: '#D2E186', inputBg: '#FFFFFF', buttonBg: '#D2E186', buttonText: '#000000', pillAbout: '#D2E186', pillActivity: '#D2E186', link: '#415111', chip: '#D2E186', dot: '#D2E186' },
  blue:   { pageBg: '#F3FDFF', cardBg: '#B7E6FF', inputBg: '#FFFFFF', buttonBg: '#B7E6FF', buttonText: '#000000', pillAbout: '#9FC9DF', pillActivity: '#9FC9DF', link: '#2248A4', chip: '#9FC9DF', dot: '#B7E6FF' },
  pink:   { pageBg: '#FDF5EF', cardBg: '#FFD6DC', inputBg: '#FFFFFF', buttonBg: '#FFD6DC', buttonText: '#000000', pillAbout: '#FFBDC8', pillActivity: '#FFBDC8', link: '#FF6874', chip: '#FFBDC8', dot: '#FFD6DC' },
};

export const THEME_ORDER: Theme[] = ['orange', 'green', 'blue', 'pink'];

// 设计稿画布尺寸
export const STAGE_W = 1920;
export const STAGE_H = 1080;

// 左侧卡片（设计稿坐标）
export const CARD = { left: 34, top: 28, width: 962, height: 1024, radius: 90 };

// 卡片内装饰图（坐标已换算为「相对卡片左上角」，尺寸取自 Figma 渲染边界，保证 1:1 不变形）
export type DecorKey = 'cap' | 'dots' | 'a' | 'd' | 'at' | 'quote';
export interface Decor { key: DecorKey; left: number; top: number; width: number; height: number }
export const DECOR: Decor[] = [
  { key: 'cap',   left: 536, top: 256, width: 212, height: 188 },
  { key: 'dots',  left: 444, top: 588, width: 114, height: 140 },
  { key: 'a',     left: 37,  top: 709, width: 215, height: 263 },
  { key: 'd',     left: 265, top: 815, width: 247, height: 206 },
  { key: 'at',    left: 546, top: 728, width: 236, height: 245 },
  { key: 'quote', left: 837, top: 667, width: 125, height: 110 },
];

// 装饰图配色矩阵：每个装饰是单色形状，4 套主题下仅填充色不同。
// 故只保留 1 个去色几何 SVG（/images/login/deco-{key}.svg），用 CSS mask 上色，
// 颜色由这里查表 → 24 个彩色 SVG 收敛为 6 个。详见 CLAUDE.md「单色 SVG 去重」。
export const DECOR_COLORS: Record<Theme, Record<DecorKey, string>> = {
  orange: { a: '#FF9E7B', d: '#9CEA4F', cap: '#FFD57B', dots: '#5BC9E8', at: '#E7FD93', quote: '#FFF8F1' },
  green:  { a: '#FB8159', d: '#5BC9E8', cap: '#FFF8F1', dots: '#E850A1', at: '#415111', quote: '#FCBF93' },
  blue:   { a: '#E850A1', d: '#E7FD93', cap: '#FFD57B', dots: '#5BC9E8', at: '#2248A4', quote: '#FC683A' },
  pink:   { a: '#FEFCEA', d: '#FC683A', cap: '#E850A1', dots: '#E7FD93', at: '#5BC9E8', quote: '#FCBF93' },
};
